import { toEchartData } from '../dataProcessor';
import getTooltipFormatter from 'src/components/Charts/tooltipResolver';
import { FUNNEL } from 'src/components/Charts/types';
import { round } from 'src/util/numbers/rounder';
import legendTooltipFormatter from './legendTooltipFormatter';
import { capitalizeText } from 'src/util/formatters/stringNormalizer';

export default function toEchartOption(resultadosGerais, theme, chartFontSize = 14, disabledLegends = [], highlitIndex) {
  const { data } = toEchartData(resultadosGerais);
  // Considera o caso em que existem consolidações
  const formatter = getTooltipFormatter(resultadosGerais, FUNNEL);

  const orderedLegendsWithIcon = data
    .map((dataItem) => ({
      name: dataItem.name,
      icon: 'circle',
      value: dataItem.value,
      numeric: dataItem.numeric,
    }))
    .sort((first, second) => second.numeric - first.numeric)
    // apply highlit
    .map((dataItem, dataIndex) => ({
      ...dataItem,
      itemStyle: {
        ...(dataIndex === highlitIndex ? {
          borderType: theme.highlitedItemBorderType,
          borderColor: theme.highlitedItemBorderColor,
          borderWidth: theme.highlitedItemBorderWidth,
        } : {})
      }
    }))

  const selectedLegends = {};

  orderedLegendsWithIcon.forEach(({ name }) => {
    selectedLegends[name] = !disabledLegends.includes(name);
  });

  return {
    animationDuration: 0,
    color: theme.colors,
    visibleLegends: orderedLegendsWithIcon,
    tooltip: {
      show: true,
      trigger: 'item',
      formatter,
    },
    legend: {
      selected: selectedLegends,
      tooltip: {
        show: true,
        trigger: 'item',
        formatter: legendTooltipFormatter(orderedLegendsWithIcon, disabledLegends, formatter),
      },
      orient: 'horizontal',
      x: 'center',
      data: orderedLegendsWithIcon,
      type: 'scroll',
      textStyle: {
        fontSize: chartFontSize,
        color: theme.legend.color,
        fontFamily: 'Roboto, sans-serif'
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    series: [
      {
        type: 'funnel',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        label: {
          textStyle: {
            fontSize: chartFontSize,
            color: theme.label.text,
          },
          normal: {
            show: false,
            position: 'center',
            formatter: (params) => `${round(params.data.value, 1)}%`,
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '15',
              fontWeight: 'bold',
            },
          },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        data: orderedLegendsWithIcon.map(({ name, value, numeric }) => ({ name, value, numeric })),
      },
    ],
  };
}